// eslint-disable-next-line import/prefer-default-export
var SpeedMetric;
(function (SpeedMetric) {
    SpeedMetric["KPH"] = "kph";
    SpeedMetric["MPH"] = "mph";
})(SpeedMetric || (SpeedMetric = {}));

export { SpeedMetric };
//# sourceMappingURL=speed.js.map
